import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.waitItem = {
        ...data
      }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        // const method =await _this.activityTab === 1 ? api.JournalDelete : api.nextDelete
        const res = _this.activityTab === 1 ? await api.JournalDelete({
          id: data.id
        }) : await api.nextDelete({
          id: data.id
        })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.$emit('updateList')
        }
      }
    })
  }
}
